<div #modalRoot *ngIf="user.profileId !== 2" class="modal fade" tabindex="-1" [id]="'reassignModal' + (id ? '-' + id : '')">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <i *ngIf="canceledUpgradeSameType" class="bi bi-exclamation-triangle fs-1 text-danger mb-2"></i>
                <i *ngIf="!canceledUpgradeSameType" class="action_reassign_icon"></i>
                <h4 class="modal-title fw-bold">{{ (action === 'reassign' ? 'COMMON.REASSIGN_PACKAGE' :
                    'COMMON.MODIFY_PACKAGE') | translate }}</h4>
            </div>
            <div class="modal-body text-center">
                <p *ngIf="!canceledUpgradeSameType">{{ (action === 'reassign' ? 'COMMON.REASSIGN.REASSIGN_PACKAGE' :
                    'COMMON.MODIFY.MODIFY_PACKAGE')|
                    translate:{ x: presetPackage ? presetPackage.id : id } }}</p>
                <p *ngIf="canceledUpgradeSameType">{{ 'COMMON.CONTACT_CUSTOMER_SERVICE'|translate}}</p>
            </div>
            <form *ngIf="!canceledUpgradeSameType" [formGroup]="reassignForm" (ngSubmit)="reassign()">
                <div class="reassign_container">
                    <div *ngIf="action==='reassign'" class="reassign_container_row">
                        <div>{{'COMMON.REASSIGN.REASSIGN_ENTITY'| translate }}</div>
                        <div>
                            <!--<hbo-single-select-multi-level *ngIf="parentEntities.length" [tree]="parentEntities"
                                [typeData]="'located'" [max]="entity.entityTypeId" [selection]="entity"
                                formControlName="parentEntityId">
                            </hbo-single-select-multi-level>-->
                            <!--<hbo-multi-select-multi-level *ngIf="typeData" [typeData]="typeData"
                                (callback)="callbackPartners($event)" [search]="selectorEntitiesSearch">

                            </hbo-multi-select-multi-level>-->
                            <!--<hbo-single-select-multi-level *ngIf="data.length" [data]="data"
                                [typeData]="'reassignPackage'" [max]="entity.entityTypeId" [selection]="entity"
                                (ngModelChange)="onChange($event,'entity')" formControlName="entityId">
                            </hbo-single-select-multi-level>-->
                            <app-basic-virtual-scroll *ngIf="configSvc.currentConfigValue.childEntities"
                                (callback)="onChange($event,'entity')"
                                [customTreeNode]="presetPackage ? presetEntities : undefined"
                                [reloadToken]="treeReloadToken"
                                [disableNode]="disableNonOpticals"
                                [typeData]="'reassignPackage'"></app-basic-virtual-scroll>
                            <hbo-control-messages [control]="reassignForm.get('entityId')!"></hbo-control-messages>
                        </div>
                    </div>
                    <div class="reassign_container_row">
                        <div>{{'COMMON.REASSIGN.REASSIGN_TYPE' | translate }}</div>
                        <div class='form-select-ng '>
                            <ng-select [searchable]="false" formControlName="type" labelForId="yesno"
                                [readonly]="!!presetPackage"
                                placeholder="{{'DATATABLE.FILTERS.RESULTTYPE' | translate}}"
                                (ngModelChange)="onChange($event,'type')" [ngClass]="{'selector-disabled':action==='create' && !reassignForm.get('entityId')!.value}"><!--
                                    Support for using the ngModel input property and ngModelChange event with
                                    reactive form directives has been deprecated in Angular v6 and will be removed
                                    in a future version of Angular
                                    [(ngModel)]="selectedType"
                                    (ngModelChange)="onChange($event,'type')"
                                -->
                                <ng-option *ngFor="let option of selectableTypes"
                                    [value]="option.id">{{option.name}}</ng-option>
                            </ng-select>
                            <hbo-control-messages [control]="reassignForm.get('type')!"></hbo-control-messages>
                        </div>
                    </div>
                    <div *ngIf="!presetPackage && !assignmentBlocked" class="reassign_container_row  available_row">{{(selectedType ?'['+getTypeName(selectedType) +
                        '] ':'')+
                        ('COMMON.REASSIGN.REASSIGN_AVAILABLE' | translate)}} : {{selectedType ? availablePackages :
                        '···'}} </div>
                    <div *ngIf="!presetPackage && !assignmentBlocked && headoffice && reassignForm.get('type')!.value"
                        class="reassign_container_row  available_row">
                        <div class="form-check mb-3">
                            <input class="form-check-input" type="checkbox" [id]="'headofficeAvailable'"
                                [checked]="takeHeadOfficeAvalilable" (change)="headofficeSelected(true)"
                                [disabled]="!availablePackageHeadOffice?.length || !availablePackageDist?.length"
                                [ngClass]="{'entityType-select-pb-disable':takeHeadOfficeAvalilable}">
                            <label class="form-check-label" [for]="'headofficeAvailable'">
                                {{ 'ENTITY_TYPE.3' | translate }}: {{availablePackageHeadOffice?.length}}
                            </label>
                        </div>
                        <div class="form-check mb-3">
                            <input class="form-check-input" type="checkbox" [id]="'distributorAvailable'"
                                [checked]="!takeHeadOfficeAvalilable && availablePackageDist?.length "
                                (change)="headofficeSelected(false)" [disabled]="!availablePackageDist?.length"
                                [ngClass]="{'entityType-select-pb-disable':!takeHeadOfficeAvalilable}">
                            <label class="form-check-label" [for]="'distributorAvailable'">
                                {{ 'ENTITY_TYPE.2' | translate }}: {{availablePackageDist?.length}}
                            </label>
                        </div>
                    </div>

                </div>
                <div *ngIf="!presetPackage && !assignmentBlocked && finalAvailablePackages$?.length" class="packages_container">
                    <div title="list container" class="packages_container_list">
                        <div *ngFor="let package of finalAvailablePackages$" class="packages_container_item">
                            <div>
                                <input class="form-check-input package-select-pb" type="checkbox"
                                    [ngClass]="{'package-select-pb-disable':package.id==packageSelectedId}"
                                    name="existingPackageRadio" [id]="package.id"
                                    [checked]="action === 'reassign' && assignedToEntityYpeId === 3 ? reassignArray.includes(package.id) : package.id==packageSelectedId"
                                    (click)="checkClicked(package)">
                            </div>
                            <div class="fw-bold">{{package.id}}</div>
                            <div class="packages_container_item_assigned">{{effectiveOwner(package).name}}</div>
                            <div>({{package.packageType.name}})</div>
                            <div>{{package.testDays}} atd</div><!--({{'LICENSE.ASSIGNED_TEST_DAYS' | translate }})-->
                        </div>

                    </div>
                </div>
                <div *ngIf="reassignError" class="single-package-message">{{ reassignError }}</div>
                <div *ngIf="policyBlocked" class="single-package-message">{{
                    'COMMON.REASSIGN.ERRORS.NO_POLICY_FOR_TYPE' | translate }}</div>
                <div *ngIf="depictConflict" class="single-package-message">{{
                    'COMMON.REASSIGN.ERRORS.ENTITY_HAS_ACTIVE_DEPICT_LICENSE' | translate }}</div>
                <div *ngIf="alignTestDaysMessage && packageSelectedId && testDays! < originTestDays!"
                    class="single-package-message">{{
                    'COMMON.SURE_TO_CONTINUE_ALIGN_TEST_DAYS'| translate}}</div>
            </form>
            <button #dismissButton type="button" class="d-none" data-bs-dismiss="modal"></button>
            <div class="modal-footer">
                <button *ngIf="!canceledUpgradeSameType" type="button" class="btn btn-outline-secondary"
                    data-bs-dismiss="modal">{{
                    'COMMON.REASSIGN.REASSIGN_CANCEL' |
                    translate }}</button>
                <button *ngIf="canceledUpgradeSameType" type="button" class="btn btn-outline-secondary"
                    (click)="cancelSameTypeModal()">{{
                    'COMMON.REASSIGN.REASSIGN_CANCEL' |
                    translate }}</button>
                <button *ngIf="!canceledUpgradeSameType"
                    [disabled]="assignmentBlocked || (packageSelectedId ? false : action === 'reassign'  ? !reassignArray.length : confirmDisabled) "
                    type="button" class="btn btn-dark" (click)="reassign()">{{
                    'COMMON.REASSIGN.REASSIGN_CONFIRM' | translate }}</button>
            </div>

        </div>
    </div>
</div>